const P = (k) => `/photos/catalogue/${k}.jpg`;

export const CATALOGUE = [
  { key: "tshirt", label: "T-shirts", offer: "vetements", photo: P("tshirt-classique"), hint: "Équipe, événement, boutique", variants: [
    { key: "classique", label: "Classique", photo: P("tshirt-classique") },
    { key: "oversize", label: "Oversize", photo: P("tshirt-oversize") },
    { key: "oversize-boxy", label: "Oversize boxy", photo: P("tshirt-boxy") },
    { key: "oversize-crop", label: "Oversize crop", photo: P("tshirt-oversize-crop") },
    { key: "oversize-lourd", label: "Oversize lourd", photo: P("tshirt-oversize-lourd") },
    { key: "evenementiel", label: "Événementiel (consommable)", photo: P("tshirt-evenement") },
  ] },
  { key: "polo", label: "Polos", offer: "vetements", photo: P("polo-mc"), hint: "Accueil, service, terrain", variants: [
    { key: "manche-courte", label: "Manche courte", photo: P("polo-mc") },
    { key: "manche-longue", label: "Manche longue", photo: P("polo-ml") },
    { key: "polyester", label: "Polyester sport", photo: P("polo-poly") },
  ] },
  { key: "sweat", label: "Sweats", offer: "vetements", photo: P("hoodie"), hint: "Équipe, club, merchandising", variants: [
    { key: "crewneck", label: "Crewneck", photo: P("sweat-col-rond") },
    { key: "hooded", label: "Hooded", photo: P("hoodie") },
    { key: "zippe", label: "Zippé", photo: P("sweat-zippe") },
  ] },
  { key: "veste", label: "Vestes, polaires & manteaux", offer: "vetements", photo: P("polaire"), hint: "Extérieur, chantier, hiver", variants: [
    { key: "polaire", label: "Polaire", photo: P("polaire") },
    { key: "softshell", label: "Softshell", photo: P("softshell") },
    { key: "doudoune-sans-manches", label: "Doudoune sans manches", photo: P("doudoune-sans-manches") },
    { key: "doudoune", label: "Doudoune", photo: P("doudoune") },
    { key: "parka", label: "Parka", photo: P("parka") },
  ] },
  { key: "casquette", label: "Casquettes & bonnets", offer: "accessoires", photo: P("casquette-trucker"), hint: "Logo brodé sur la face", variants: [
    { key: "dad-hat", label: "Dad hat", photo: P("casquette-classique") },
    { key: "trucker", label: "Trucker", photo: P("casquette-trucker") },
    { key: "5-panneaux", label: "5 panneaux", photo: P("casquette-5panneaux") },
    { key: "bonnet", label: "Bonnet", photo: P("bonnet") },
    { key: "bob", label: "Bob", photo: P("bob") },
  ] },
  { key: "accessoires", label: "Accessoires", offer: "accessoires", photo: P("tote-bag"), hint: "Tote bags, serviettes, tabliers…", variants: [
    { key: "tote", label: "Tote bag", photo: P("tote-bag") },
    { key: "linge", label: "Serviette / linge", photo: P("serviette") },
    { key: "chemise", label: "Chemise", photo: P("chemise") },
    { key: "autre", label: "Autre", photo: null },
  ] },
];

export const CAT_CATEGORY = { tshirt: "T-shirt", polo: "Polo", sweat: "Sweat", veste: "Veste / polaire / manteau", casquette: "Casquette / bonnet", accessoires: "Accessoire", conseil: "À conseiller" };

export const ZONES = { vetements: ["Cœur", "Dos", "Manche", "Nuque"], accessoires: ["Face", "Côté", "Arrière"] };
